module.exports = __webpack_public_path__ + "static/media/doctor-online.1cd73666.svg";